import { render, staticRenderFns } from "./sxMarketing.vue?vue&type=template&id=3b3a263b&scoped=true&"
import script from "./sxMarketing.vue?vue&type=script&lang=js&"
export * from "./sxMarketing.vue?vue&type=script&lang=js&"
import style0 from "./sxMarketing.vue?vue&type=style&index=0&id=3b3a263b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3a263b",
  null
  
)

export default component.exports